import { useEffect, useState, useCallback } from 'preact/hooks';
import { storefrontClient } from '../lib/storefrontClient';

/**
 * Hook for making GraphQL requests to Storefront API
 * @param {string} query - GraphQL query string
 * @param {object} variables - GraphQL variables
 * @param {object} options - Hook options
 * @param {boolean} options.skip - Skip the query execution
 * @returns {[data, loading, error, refetch]}
 */
function useStorefrontAPI(query, variables = {}, options = {}) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async () => {
        if (options.skip) {
            setLoading(false);
            return;
        }

        try {
            setLoading(true);
            setError(null);
            
            const result = await storefrontClient.graphql(query, variables);
            setData(result);
        } catch (err) {
            console.error('Storefront API error:', err);
            setError(err.message || 'Failed to fetch data');
        } finally {
            setLoading(false);
        }
    }, [query, JSON.stringify(variables), options.skip]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const refetch = useCallback(() => {
        return fetchData();
    }, [fetchData]);

    return [data, loading, error, refetch];
}

export default useStorefrontAPI;
